// 2026-11-03 - FormuLearning - 쓰기·실행 가능 여부 훅 (이슈 #114 viewer 역할)
// 파일 위치: frontend/src/hooks/useCanWrite.ts
// viewer(조회 전용)면 false. 액션 버튼·편집 셀은 숨기지 않고 `disabled={!canWrite}` +
// `title={canWrite ? … : READ_ONLY_TITLE}` 로 비활성으로 보인다. 탐색(스텝 이동·탭·페이지·확대·그래프 클릭)은 막지 않는다.
// 사용자 정보를 읽기 전(user=null)에는 true — 일반 계정의 깜빡임을 피한다. 그 사이 요청은 백엔드가 막는다.

import { useAuthStore } from '../stores/authStore'
import { ROLE_VIEWER } from '../lib/readOnly'

export function useCanWrite(): boolean {
  return useAuthStore((s) => s.user?.role !== ROLE_VIEWER)
}

export { READ_ONLY_TITLE } from '../lib/readOnly'
